import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';
var ZipCodeComponent = /** @class */ (function () {
    function ZipCodeComponent(activeModal, localSt) {
        this.activeModal = activeModal;
        this.localSt = localSt;
        this.zipCodes = [];
        this.zipCodeMatched = 1;
    }
    ZipCodeComponent.prototype.ngOnInit = function () {
        this.createForm();
    };
    ZipCodeComponent.prototype.createForm = function () {
        this.zipCodeForm = new FormGroup({
            zipCodeField: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
        });
    };
    ZipCodeComponent.prototype.closeModal = function (status) {
        this.activeModal.close(status);
    };
    ZipCodeComponent.prototype.checkZipFunction = function () {
        this.zipCodes = this.localSt.retrieve('zipCodes');
        for (var i = 0; i < this.zipCodes.length; i++) {
            var item = this.zipCodes[i];
            if (Number(item.zf_zip_code) === Number(this.zipCodeForm.value.zipCodeField)) {
                this.zipCodeMatched = 2;
                this.localSt.store('validZipCode', item.zf_zip_code);
                break;
            }
            else {
                this.zipCodeMatched = 3;
            }
        }
    };
    return ZipCodeComponent;
}());
export { ZipCodeComponent };



// WEBPACK FOOTER //
// ./src/app/modules/shared/zip-code/zip-code.component.ts.pre-build-optimizer.js